module.exports = __webpack_public_path__ + "images/thumb-200dc230c2bc4125eaf1dc8346c6f318.jpg";